import { render, staticRenderFns } from "./NoticeAll.vue?vue&type=template&id=3f8f802e&scoped=true&"
import script from "./NoticeAll.vue?vue&type=script&lang=js&"
export * from "./NoticeAll.vue?vue&type=script&lang=js&"
import style0 from "./NoticeAll.vue?vue&type=style&index=0&id=3f8f802e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f802e",
  null
  
)

export default component.exports